import { Facebook, Instagram, LinkedIn, WSLogoSmall } from "@/assets/Icons";
import { cn } from "@/lib/utils";
import CustomLink from "./CustomLink";
import AppText from "./AppText";
import AppButton from "../buttons/AppButton";
import { BODY_SMALL_EMPHASIS } from "@/styles";
import { IFooterProps } from "./Footer";

const SecondaryFooter: React.FC<IFooterProps> = ({ data, allRightsReserved, dict }) => {
  return (
    <>
      <div
        className="w-full mx-auto xl:max-w-screen-2xl lg:max-w-screen-xl sm:max-w-screen-md md:max-w-screen-lg
            sm:py-8 py-4 px-4 lg:px-8 xl:px-6 2xl:px-[104px]"
      >
        <div className="last_footer">
          <div className="last_footer_left">
            <CustomLink href="/" ariaLabel={dict.buttonLogo}>
              <WSLogoSmall />
            </CustomLink>
            <AppText type="BODY_SMALL">{allRightsReserved}</AppText>
          </div>
          <div className="last_footer_mid">
            {data.whiteFooterLinks.map((link: { [key: string]: string }) => (
              <AppButton
                key={link.id}
                link={link.link}
                label={link.label}
                intent="ghost"
                className={cn(BODY_SMALL_EMPHASIS)}
              />
            ))}
          </div>
          <div className="last_footer_right">
            <a
              aria-label="LinkedIn link"
              target="_blank"
              href={data.socialsLinkedIn}
              className="flex items-center justify-center w-6 h-6 bg-white rounded cursor-pointer"
            >
              <LinkedIn />
            </a>
            <a
              aria-label="Facebook link"
              target="_blank"
              href={data.socialsFacebook}
              className="flex items-center justify-center w-6 h-6 bg-white rounded cursor-pointer"
            >
              <Facebook />
            </a>
            <a
              aria-label="Instagram link"
              target="_blank"
              href={data.socialsInstagram}
              className="flex items-center justify-center w-6 h-6 bg-white rounded cursor-pointer"
            >
              <Instagram />
            </a>
          </div>
        </div>
        <AppText type="BODY_SMALL">{data.footerText}</AppText>
      </div>
    </>
  );
};

export default SecondaryFooter;
